import { render, staticRenderFns } from "./MetaSetAdd.vue?vue&type=template&id=1bf8b380&"
import script from "./MetaSetAdd.vue?vue&type=script&lang=js&"
export * from "./MetaSetAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports